import React from 'react';

export interface CompartirIconProps {
  size?: number | string;
  color?: string;
  className?: string;
}

const CompartirIcon: React.FC<CompartirIconProps> = ({ 
  size = 24, 
  color = 'currentColor',
  className = '' 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ color }}
    >
      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m8.924 13.834 6.83 3.98m-.01-10.98-6.82 3.98m12.41-5.49a3 3 0 1 1-6 0 3 3 0 0 1 6 0m-12 7a3 3 0 1 1-6 0 3 3 0 0 1 6 0m12 7a3 3 0 1 1-6 0 3 3 0 0 1 6 0"/>
    </svg>
  );
};

export default CompartirIcon;
